import React, { useMemo } from 'react';
import { withTheme, DefaultTheme } from 'styled-components';
import { StyContainer, StyProgress, StyProgressContent } from './styles';
import { Typography } from '../../Typography';

type LinearBarColor = 'neutral' | 'blue' | 'red' | 'orange' | 'green';

interface ILinearBar {
  percentage?: number;
  color?: LinearBarColor;
  customColor?: string;
  maxSize?: string | number;
  height?: string;
  theme?: DefaultTheme;
}

export const LinearBar: React.FC<ILinearBar> = withTheme(
  ({
    percentage = 0,
    maxSize,
    color = 'green',
    height = '6px',
    customColor,
    theme,
  }) => {
    const progressColorMap: Record<LinearBarColor, string> = {
      neutral: theme.neutral[500],
      blue: theme.blue[500],
      red: theme.red[500],
      orange: theme.orange[500],
      green: theme.green[500],
    };
    const progressColor: string = customColor || progressColorMap[color];
    const refixedSize = useMemo(
      () =>
        typeof maxSize === 'number'
          ? `${maxSize}px`
          : typeof maxSize === 'string' && !maxSize.endsWith('px')
          ? `${maxSize}px`
          : maxSize,
      [maxSize]
    );

    return (
      <StyContainer>
        <StyProgressContent maxSize={refixedSize} height={height}>
          <StyProgress percentage={percentage} progressColor={progressColor} />
        </StyProgressContent>
      </StyContainer>
    );
  }
);
